'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)t = i[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
t.string;
const Pagination = renderWithRef('Pagination', null, (r, o)=>{
    var { children: c, accessibleText: p } = r, a = _object_without_properties(r, [
        "children",
        "accessibleText"
    ]);
    return useComponentStylesLoaded('Pagination', SWAN_STYLE_KEY_MAP.pagination), jsx(RenderComp, {
        root: "nav",
        classNames: [
            'swan-pagination'
        ],
        forwardedRef: o,
        props: _object_spread_props(_object_spread({
            'aria-label': null != p ? p : void 0
        }, a), {
            role: 'navigation'
        }),
        children: jsx("ul", {
            children: c
        })
    });
});

export { Pagination };
